import apiClient from "../core/HttpClient";
import { ExerciseLoadType } from "../models";

export default class ExerciseLoadTypeService{
    url="/ExerciseLoadTypes";
    async getExerciseLoadTypes(){
        return apiClient.get(this.url).then((response) => {
            return response.data;
        });        
    }
    async getExerciseLoadType(id: number){
        return apiClient.get(`${this.url}/${id}`).then((response) => {
            return response.data;
        });        
    }

    async addExerciseLoadType(data: ExerciseLoadType){
        return apiClient.post(this.url, data);
    }

    async updateExerciseLoadType(id: number, data: ExerciseLoadType){
        return apiClient.put(`${this.url}/${id}`, data);
    }

    async deleteExerciseLoadType(id: number){
        return apiClient.delete(`${this.url}/${id}`).then((response) => {
            return response.data;
        });
    }
    
    
}
